import axios from "axios";
import React, {Component} from "react";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from 'feather-icons-react';

class   Accoutingbalance_ extends Component{

    state = {
        id : "",
        accoutingbalances : [],
        isModal : false,
        title : "",
    }

    formatPerson = (user) => {
        return [user?.last_name, user?.family_name, user?.first_name].filter(Boolean).join(" ") || "-";
    }

    formatClass = (student) => {
        const sectionclass = student?.sectionclass;
        return [
            sectionclass?.class?.short_entitled_class,
            sectionclass?.title,
            sectionclass?.section?.short_entitled_section
        ].filter(Boolean).join(" ") || "-";
    }

    formatMoney = (value, currency) => {
        const amount = parseFloat(value || 0);
        if(!amount) return "-";
        return `${amount.toLocaleString()} ${currency || ""}`.trim();
    }

    getWording = (val) => {
        if(val.expensedetail?.typesalary?.type) return val.expensedetail.typesalary.type;
        if(val.expensedetail?.reason) return val.expensedetail.reason;

        return [
            val.schoolfee?.trimesectschool?.trimester?.short_trimester,
            val.schoolfee?.sectionschoolfeecategory?.schoolfeecategory?.category
        ].filter(Boolean).join(" ") || "-";
    }

    edit=()=>  {
        this.form()
    }

    form= async()=>{
        var accoutingbalance = await axios.get(`accountingbalances/${ this.props.chartacountId }/${this.props.date}`);
        if(accoutingbalance.status === 200){
            this.setState({ accoutingbalances : accoutingbalance.data })
        }
    }

    render(){
        
        return(
            <div>
            <Modal 
                show={this.props.isModal} 
                onHide={this.props.showModal}
                size="lg"
                dialogClassName="finance-ledger-details-modal"
                onEntered={this.edit}
                centered
                backdrop={"static"}>
                <Modal.Header className="finance-ledger-details-modal__header">
                    <div className="finance-ledger-details-modal__title">
                        <span><FeatherIcon icon="file-text" size="20" /></span>
                        <div>
                            <small>Details de paiement</small>
                            <Modal.Title as="h2">
                                { this.props.chartacount || "Caisse" }
                            </Modal.Title>
                        </div>
                    </div>
                    <b>{ this.props.date ? new Date(this.props.date)?.toLocaleDateString('en-GB') : "-" }</b>
                </Modal.Header>
                    <Modal.Body>
                        <div className="table-responsive finance-ledger-table-wrap">
                            <table className="table table-sm finance-ledger-table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Beneficiaire</th>
                                        <th>Classe</th>
                                        <th>Montant</th>
                                        <th>Motif</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.accoutingbalances?.length === 0 && (
                                            <tr>
                                                <td colSpan="5" className="finance-ledger-state">Aucun detail disponible pour cette date.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        this.state.accoutingbalances?.map((val, index) => {
                                            const beneficiary = val.schoolfee ? this.formatPerson(val.schoolfee?.student?.user) : this.formatPerson(val.expensedetail?.staff?.user);
                                            const currency = val.chartaccount?.currency || val.chartacount?.currency;
                                            const amount = val.debit > 0 ? val.debit : val.credit;

                                            return (
                                                <tr key={val.id || index}>
                                                    <td align="right">{ index+1 }</td>
                                                    <td><span className="finance-ledger-account">{beneficiary}</span></td>
                                                    <td>{ this.formatClass(val.schoolfee?.student) }</td>
                                                    <td align="right" className={`finance-ledger-money ${val.debit > 0 ? "is-in" : "is-out"}`}>{ this.formatMoney(amount, currency) }</td>
                                                    <td>{ this.getWording(val) }</td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="finance-ledger-details-modal__footer">
                        <span>{this.state.accoutingbalances?.length || 0} ligne(s)</span>
                        <div>
                            <button onClick={this.props.showModal} className="finance-ledger-details-modal__close" type="button"><FeatherIcon icon="corner-down-left" size="16"></FeatherIcon> <span>Fermer</span></button>
                        </div>
                    </Modal.Footer>
            </Modal>
            
        </div>
        )
    }
}
export default Accoutingbalance_;



